import React from "react";
import {
  Building2,
  CircleUserRound,
  FileText,
  Gift,
  Image,
  Layers,
  LayoutDashboard,
  LogOut,
  Mail,
  MessageSquareText,
  MessageCircle,
  Package,
  Plug,
  Printer,
  RotateCcw,
  Send,
  Settings,
  ShieldAlert,
  ShoppingBag,
  Sparkles,
  Ticket,
  Users,
} from "lucide-react";

export const ADMIN_TABS = [
  { k: "dash", t: "Dashboard", i: LayoutDashboard },
  { k: "my-profile", t: "My Profile", i: CircleUserRound },
  { k: "products", t: "Products", i: Package },
  { k: "categories", t: "Categories", i: Layers },
  { k: "brands", t: "Brands", i: Sparkles },
  { k: "banners", t: "Banners", i: Image },
  { k: "campaigns", t: "Campaigns", i: Sparkles },
  { k: "coupons", t: "Coupons", i: Ticket },
  { k: "orders", t: "Orders", i: ShoppingBag },
  { k: "returns", t: "Returns", i: RotateCcw },
  { k: "purchases", t: "Purchase Management", i: FileText },
  { k: "customers", t: "Customers", i: Users },
  { k: "account-deletions", t: "Account Deletions", i: ShieldAlert },
  { k: "eira-points", t: "Eira Points", i: Gift },
  { k: "reviews", t: "Feedback & Reviews", i: MessageSquareText },
  { k: "support-tickets", t: "Support Tickets", i: MessageCircle },
  { k: "corporate-enquiries", t: "Corporate Enquiries", i: Building2 },
  { k: "email-templates", t: "Email Templates", i: Mail },
  { k: "email-delivery", t: "Email Delivery", i: Send },
  { k: "integrations", t: "Integrations", i: Plug },
  { k: "print", t: "Print", i: Printer },
  { k: "settings", t: "Settings", i: Settings },
];

export const AdminSidebar = ({ tab, setTab, onLogout, user }) => (
  <aside className="hidden w-60 bg-[#1E2A24] px-4 py-8 text-white sm:block sm:h-screen sm:overflow-y-auto">
    <button
      type="button"
      onClick={() => setTab("my-profile")}
      className="mb-8 flex w-full items-center gap-3 border-b border-white/10 px-2 pb-5 text-left hover:text-white/90"
      data-testid="admin-sidebar-profile"
    >
      {user?.picture ? (
        <img src={user.picture} alt="" className="h-10 w-10 rounded-full object-cover" />
      ) : (
        <div className="flex h-10 w-10 items-center justify-center rounded-full bg-[#C86D42] font-serif text-base">
          {(user?.name || "Admin").trim().slice(0, 1).toUpperCase()}
        </div>
      )}
      <span className="min-w-0">
        <span className="block truncate font-serif text-lg">{user?.name || "Admin"}</span>
        <span className="block text-[10px] uppercase tracking-widest text-white/60">Eira Admin</span>
      </span>
    </button>
    {ADMIN_TABS.map((item) => (
      <button
        key={item.k}
        type="button"
        onClick={() => setTab(item.k)}
        className={`mb-1 flex w-full items-center justify-start gap-3 rounded-lg px-3 py-2.5 text-left text-sm font-medium ${
          tab === item.k ? "bg-[#C86D42]" : "hover:bg-white/10"
        }`}
        data-testid={`admin-tab-${item.k}`}
      >
        <item.i size={16} className="shrink-0" />
        <span className="min-w-0 truncate">{item.t}</span>
      </button>
    ))}
    <a
      href="https://eiraproducts.com"
      target="_blank"
      rel="noopener noreferrer"
      className="mt-8 block px-3 text-xs text-white/60 hover:text-white"
      data-testid="admin-back-to-store-link"
    >
      ← Back to store
    </a>
    <button
      type="button"
      onClick={onLogout}
      className="mt-3 flex w-full items-center gap-2 px-3 py-2 text-xs text-white/60 hover:text-white"
      data-testid="admin-logout-button"
    >
      <LogOut size={14} />
      Logout
    </button>
  </aside>
);